import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/reset.less';
import '@/styles/element-custom.less';
import '@/styles/theme/index.css'
import * as echarts from 'echarts'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ElTreeSelect from 'el-tree-select';
Vue.use(ElTreeSelect);
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts

import '@/styles/public.less'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')